const labels = {
    /* General texts and messages */
    "thanks": "ՇՆՈՐՀԱԿԱԼՈՒԹՅՈՒՆ",
    "messageSent": "ՁԵՐ ՀԱՅՏԸ ՀԱՋՈՂՈՒԹՅԱՆԲ ՈՒՂԱՐԿՎԵԼ Է: <br />ՇՈՒՏՈՎ ՄԵՐ ՄԱՍՆԱԳԵՏՆԵՐԸ ԿԿԱՊՆՎԵՆ <br />ՁԵԶ ՀԵՏ:",
    "dearCustomer": "Հարգելի՛ հաճախորդ,",
    "dearCustomerInvitation": "Խնդրում ենք լրացնել համապատասխան դաշտերը",
    "dearCustomerSteps": "Ստացի՜ր գերարագ բիզնես վարկ մի քանի գործողությամբ",
    "optional": "Տվյալ էջը պարտադիր չէ լրացման համար, սակայն ցանկալի է",
    "flowInstruction": "Գործող ընթացակարգերի համաձայն վարկավորումը իրամանացվում է 6 ամիս լրացած գործունեության դեպքում",
    "currentPastDue": "Գործող ուշացման պարագայում, ցավոք, չենք կարող դիտարկել Ձեր հայտը",
    "shortLastOfBusiness": "Բիզնես Վարկի դիտարկման համար պետք է առնվազն 6 ամիս գործող Բիզնեսի առկայություն",
    "pleaseWait": "Խնդրում ենք սպասել",
    "formFilling": "ՀԱՅՏԻ ԼՐԱՑՈՒՄ",
    "yourCredit": "ՍՊԱՌՈՂԱԿԱՆ ՎԱՐԿ <br /> ՄԻԿՐՈ",
    "yourCreditAttention": "ՀԱՎԱՏԱ ՔՈ ՆՊԱՏԱԿՆԵՐԻՆ,",
    "yourCreditAttention1": "ՉԷ՞ ՈՐ՝",
    "yourCreditProposal": "ԱՄԵՆ ԻՆՉ ՍԿՍՎՈՒՄ Է ՓՈՔՐԻՑ",
    "weProvide": "ՄԵՆՔ <br />ՏՐԱՄԱԴՐՈՒՄ ԵՆՔ",
    "weProvideCredits": "ՄԻՆՉև <span class=\"amount\">2.5</span> <br /> ՄԼՆ ՀՀ ԴՐԱՄ (ՀԱՄԱՐԺԵՔ ԱՄՆ $) <br /><span class=\"bold\">ԱՌԱՆՑ ԲԻԶՆԵՍ ՎԱՅՐ ԱՅՑԵԼՈՒԹՅԱՆ</span>",
    "weProvideCreditsNoPledge": "ԲԻԶՆԵՍ ՎԱՐԿԵՐ ՄԻՆՉև <span class=\"amount\">10</span><br /> ՄԼՆ ՀՀ դրամ (համարժեք ԱՄՆ դոլար) <span class=\"bold\">ԱՌԱՆՑ ԳՐԱՎԻ</span> <br/> Մինչև 1 օր <br /> Որոշման կայացման ժամկետ",
    "attention": "ՈՒՇԱԴՐՈՒԹՅՈՒՆ՝ ՏԵՂԵԿԱՑՆՈՒՄ ԵՆՔ, ՈՐ ԱՅՍ ՎԱՐԿԱՏԵՍԱԿՆԵՐՆ ՈՒՆԵՆ ԲԱՐՁՐ ՏԱՐԵԿԱՆ ՓԱՍՏԱՑԻ ՏՈԿՈՍԱԴՐՈՒՅՔ: ՈՒՍՏԻ, ՆԱԽԱՊԵՍ ԴԻՏԱՐԿԵՔ ՇՈՒԿԱՅՈՒՄ ԱՌԿԱ ՆՄԱՆԱՏԻՊ ԱՅԼ ԾԱՌԱՅՈՒԹՅՈՒՆՆԵՐԸ ԵՎ ԳՆԱՀԱՏԵՔ ՎԱՐԿԸ ՄԱՐԵԼՈՒ ՁԵՐ ՀՆԱՐԱՎՈՐՈՒԹՅՈՒՆՆԵՐԸ:",
    "mikroKapitalAddress": "ԵՐԵՎԱՆ, ՊԱՐՈՆՅԱՆ 8Շ., ՏԱՐԱԾՔ 1",
    "mikroKapitalPhone": "(012) 50 05 00",
    "mikroKapitalNotice": "Հարթակը պատկանում է «Միկրո Կապիտալ Հայաստան» ՈւՎԿ ՓԲԸ–ին: «Միկրո Կապիտալ Հայաստան» ՈւՎԿ ՓԲԸ կողմից մատուցվող ծառայությունների համար ամբողջական տեղեկատվություն ստանալու համար անհրաժեշտ է այցելել «Միկրո Կապիտալ Հայաստան» ՈւՎԿ ՓԲԸ պաշտոնական ինտերնետային կայք՝ www.mikrokapital.am",
    "productActivityRestriction":"Նշված գործունեության տեսակը նախատեսված չէ ընտրված վարկատեսակի համար",
    "productbusinessPeriodRestriction12":"Գործունեության ժամկետը նախատեսված է 12-ից բարձր ամիսների համար",
    /* Elements */
    "borrowerLabel": "ՎԱՐԿԱՌՈՒ",
    "guarantorLabel": "ԵՐԱՇԽԱՎՈՐՈՂ",

    "ok": "ԼԱՎ",
    "next": "Հաջորդ էջ",
    "back": "Նախորդ էջ",
    "personalLabel": "ՖԻԶԻԿԱԿԱՆ ԱՆՁ",
    "selfEmployeeLabel": "ԱՆՀԱՏ ՁԵՌՆԵՐԵՑ",
    "corpLabel": "ՍՊԸ",
    "acraLabel": "ՊԱՅՄԱՆՆԵՐ, ԱՔՌԱ ՀԱՄԱՁԱՅՆՈՒԹՅՈՒՆ",
    "sendFormLabel": "Ուղարկել հայտը",
    "fillFormLabel": "ԼՐԱՑՆԵԼ ՀԱՅՏ",
    "agree": "Համաձայն եմ",
    "informed":"Ծանոթացել եմ",

    /* Labels */
    "termsLabel": "ՊԱՅՄԱՆՆԵՐ",
    "agreementLabel": "ՀԱՄԱՁԱՅՆՈՒԹՅՈՒՆ",
    "attachImagesLabel": "Խնդրում ենք կցել նկարները",
    "productTypes": "Վարկատեսակ",
    "nameLabel": "Ու՞մ երաշխավորության համար եք դիմում",
    "companyNameLabel": "Անվանում",
    "firstNameLabel": "Անուն",
    "lastNameLabel": "Ազգանուն",
    "directorFirstNameLabel": "Տնօրենի Անուն",
    "directorLastNameLabel": "Տնօրենի Ազգանուն",
    "incomeInfoLabel": "Եկամուտի մասին ինֆո / տեղեկանք աշխատավայրից (եթե առկա է)",
    "passportLabel": "Անձնագիր կամ ID քարտ",
    "socialCartLabel": "Սոցիալական քարտ",
    "birthdayLabel": "Ծննդյան ամսաթիվ",
    "phoneLabel": "Հեռախոսահամար",
    "yourPhoneLabel": "Ձեր հեռախոսահամարը",
    "realeStateLabel": "Սեփականության վկայական (եթե առկա է)",
    "yourOccupationLabel": "Գործունեության տեսակը",
    "periodLabel": "Ժամկետ (12-60 ամիս)",
    "pastDueLabel": "Ժամկետանցների առկայություն",
    "pastDueBundleLabel": "Ժամկետանցների առկայություն (այդ թվում երաշխավորության)",
    "businessPeriodLabel": "Գործունեության ժամկետ",
    "askedAmountLabel": "Պահանջվող գումար (350,000-3,000,000 ՀՀ դրամ)",
    "currencyLabel": "Արժույթ",
    "whereforeLabel": "Նպատակ",
    "resourceLabel": "Ի՞նչ աղբյուրից եք իմացել Միկրո Կապիտալի մասին",
    "responseWayLabel": "Նախընտրելի կապի տեսակ",
    "monthlyGrossLabel": "Միջին ամսական շահույթը (առանց վարկերի մարումների)",
    "monthlyNetLabel": "Միջին ամսական շրջանառությունը (ամսական վաճառք)",
    "registrationLabel": "Պետական ռեգիստրի գրանցման վկայական (եթե առկա է)",
    "registrationExistsLabel": "Պետական ռեգիստրի գրանցման վկայական",
    "monthlyPaymentLabel": "Ինշքա՞ն գումար եք պատրաստ վճարել ամեն ամիս",
    "mailingRegionLabel": "Գործունեության ռեգիոն",
    "mailingCityLabel": "Քաղաք / գյուղ",
    "mailingAddressLabel": "Հասցե",
    "companyLogoLabel": "Բիզնեսի նկար",
    "companyReportsLabel":"Հարկային հաշվետվություններ",
    "businessAdviserLabel":"Բիզնես խորհրդատու",

    "varkatesakLogoLabel": "Բանկային Քաղվածք ",
    "rulesLabel": "Կանոնադրություն (եթե առկա է)",
    "registrationNumberLabel": "Պետական ռեգիստրի գրանցման վկայականի համար",
    "hvhhLabel": "Հարկ վճարողի հաշվառման համար (ՀՎՀՀ)",
    // "passportNumberLabel": "Անձնագրի սերիա",
    "passportNumberLabel": "Սերիա",
    "hvhhRegistrationDateLabel": "Գրանցման ամսաթիվ",
    // "passportIssueDateLabel": "Անձնագրի տրման ամսաթիվ",
    "passportIssueDateLabel": "Տրման ամսաթիվ",
    "hvhhRegistrationAddressLabel": "Գրանցման հասցե",
    "passportIssuedByLabel": "Ում կողմից",
    "genderLabel": "Սեռ",
    "socialCardNumberLabel": "Սոցիալական քարտի համար",
    "middleNameLabel": "Հայրանուն",
    "registrationAddressLabel": "Հաշվարման հասցե",
    "livingAddressLabel": "Փաստացի բնակության հասցե",
    "businessAddressLabel": "Գործունեության հասցե",
    "residenceLabel": "Ռեզիդենտություն",
    "documentTypeLabel": "Փաստաթղթի տեսակ",
    "openOptionalFields": "Բացել դաշտը",
    "closeOptionalFields": "Փակել դաշտը",


    /* Placeholders */
    "namePlaceholder": "Անվանում",
    "receiverFirstNamePlaceholder": "Վարկառուի անունը",
    "receiverLastNamePlaceholder": "Վարկառուի ազգանունը",
    "yourFirstNamePlaceholder": "Ձեր անունը",
    "yourLastNamePlaceholder": "Ձեր ազգանունը",
    "yourMiddleNamePlaceholder": "Ձեր հայրանունը",
    "garantorFirstNamePlaceholder": "Երաշխավորի անունը",
    "garantorLastNamePlaceholder": "Երաշխավորի ազգանունը",

    "picturePlaceholder": "Կցել նկարը",
    "dayPlaceholder": "օր",
    "monthPlaceholder": "ամիս",
    "yearPlaceholder": "տարի",
    "addressPlaceholder": "Հասցե",
    "registrationNumberPlaceholder": "Համար",
    "hvhhPlaceholder": "Հաշվառման համար",
    // "passportNumberPlaceholder": "Ձեր անձնագիր սերիան",
    "passportNumberPlaceholder": "Սերիան",
    "passportIssuedByPlaceholder": "Ում կողմից է տրվել անձնագիրը",
    "socialCardNumberPlaceholder": "Ձեր քարտի համարը",
    "middleNamePlaceholder": "Ձեր հայրանունը",
    "registrationAddressPlaceholder": "Ձեր հաշվարման հասցեն",
    "livingAddressPlaceholder": "Ձեր հասցեն",
    "residencePlaceholder": "Ռեզիդենտություն",
    "selectedPicCount": "Կցված է {count} նկար", // "{count} files selected",
    "textmask": "+374 __ __ __ __",
    "selectPlaceholder": "-- Ընտրեք --",
    "selectedFiles": "Կցված է {count} նկար",
    "datePlaceholder": "օօ.աա.տտտտ",
    "acraAgreementTitle": "Հարգելի՛ Հաճախորդ, ",
    "acraAgreementText": "«Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ն (իրավաբանական հասցեն է` Հայաստանի Հանրապետություն, ք. Երևան, Պարոնյան 8 շենք, տարածք 1) «Անձնական տվյալների պաշտպանության մասին» ՀՀ օրենքով սահմանված կարգով իրականացնելու է Ձեր (վարկառուի, գրավատուի կամ երաշխավորի) անձնական տվյալների մշակում «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ի և Ձեր (վարկառուի, գրավատուի կամ երաշխավորի) միջև կնքվելիք պայմանագրի կատարման, ինչպես նաև պայմանագրի պայմաններից բխող և «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ի ներքին իրավական ակտերով սահմանված այլ գործողությունների իրականացման նպատակով: Անձնական տվյալների մշակումը, ի թիվս այլ գործողությունների և չսահմանափակվելով ներքոնշյալ ցանկով, ներառում է ցանկացած գործողություն կամ գործողություների խումբ, որը կապված է Անձնական տվյալները հավաքելու, ամրագրելու, մուտքագրելու, համակարգելու, կազմակերպելու, կուտակելու, պահպանելու (մասնավորապես` «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ի կողմից օգտագործվող ծրագրային ապահովումներում, վարվող հաշվետվություններում, զեկույցներում և այլ տվյալների բազաներում), փոփոխելու (թարմացում կամ վերափոխում), արտածելու, օգտագործելու, ապանձնավորելու, արգելափակելու, հեռացնելու, ջնջելու, ոչնչացնելու, ուղեփակելու, վերականգնելու, ուղղելու, ինչպես նաև ցանկացած եղանակով (այդ թվում՝ ՀՀ օրենսդրությամբ սահմանված կարգով այլ երկիր) փոխանցելու (տարածում, հասանելիության ապահովում) հետ` անկախ իրականացման ձևից և եղանակից, այդ թվում՝ ավտոմատացված, մեխանիկական, համակցված, տեխնիկանական ցանկացած միջոցների կիրառմամբ կամ առանց դրանց: Անձնական տվյալների հասանելիությունը կամ Անձնական տվյալների մշակումը սահմանափակված կլինի միայն «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ի կողմից հստակորեն լիազորված անձանց շրջանակով: «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ն Ձեր տվյալները մշակելու համար կարող է պետական կամ տեղական ինքնակառավարման մարմնից, այլ անձանցից ստանալ Ձեզ (վարկառուի, գրավատուի կամ երաշխավորի) հետ պայմանագիր կնքելու նպատակով, իր գործողությունների, ինչպես նաև իր իրավունքների և օրինական շահերի պաշտպանության համար անհրաժեշտ ցանկացած տվյալ: Մշակման ենթակա տվյալների ցանկը ներառում է Ձեր կողմից «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ին տրամադրված և հանրամատչելի աղբյուրներից ձեռք բերված անձնական տվյալները, ինչպես նաև ԱՔՌԱ Վարկային բյուրոյից, ՀՀ կենտրոնական բանկից, իրավապահ մարմիններից, այլ պետական և տեղական ինքնակառավարման մարմիններից Ձեր վերաբերյալ «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ին տրամադրված տվյալները: Ցանկը սահմանափակ չէ, և «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ն այլ աղբյուրներից ևս կարող է ստանալ Ձեր անձնական տվյալները: ՀՀ օրենսդրությամբ նախատեսված դեպքերում և կարգով, ինչպես նաև երրորդ անձանց և «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ի միջև կնքված պայմանագրերի (աուդիտորական, խորհրդատվական, ծառայությունների մատուցման, ապահովագրության պայմանագրերի կնքման և այլ նպատակներով) համաձայն` Ձեր անձնական տվյալները կարող են փոխանցվել երրորդ անձանց, այդ թվում՝ ՀՀ օրենսդրությամբ սահմանված կարգով այլ երկիր կամ վերջիններիս կարող է տրամադրվել հնարավորություն օգտվելու այդ տվյալներից: Անձնական տվյալները մշակվելու են տվյալներ մշակելու նպատակներն իրականացնելու համար օբյեկտիվորեն անհրաժեշտ ժամկետով: Տեղեկացնում ենք, որ Ձեր կողմից անձնական տվյալների, ինչպես նաև սույն համաձայնության չտրամադրումը կարող է ազդել «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ի կողմից կայացվելիք որոշման վրա: «Անձնական տվյալների պաշտպանության մասին» ՀՀ օրենքով սահմանված կարգով Դուք ունեք մշակման հետ կապված ցանկացած գործողություն կատարելու վերաբերյալ տեղեկություններ ստանալու, ինչպես նաև Ձեր կողմից տվյալների ոչնչացման կամ տվյալների մշակման դադարեցման պահանջ ներկայացնելու իրավունք: Ձեր կողմից հայցվող դադարեցման պահանջ ներկայացվում է «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ին գրավոր դիմումի միջոցով, որին ընթացք է տրվում միայն այն դեպքում, երբ դիմումում ներկայացված պահանջը հնարավոր է բավարարել` հիմք ընդունելով «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ի ներքին իրավական ակտերը և անձնական տվյալների մշակման անհրաժեշտության բացակայությունը: Սույն ծանուցման վերաբերյալ, ինչպես նաև այլ հարցերի դեպքում կարող եք դիմել «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸի ցանկացած գրասենյակ:",
    "acreAgreement": "ՀԱՄԱՁԱՅՆՈՒԹՅՈՒՆ",
    "acraAgreementDesc": "«Հավաստում եմ, որ սույնով ծանուցվել եմ «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ի կողմից իմ տվյալների մշակման մտադրության մասին, ծանոթացել եմ սույն ծանուցման բովանդակությանը, չեմ առարկում։ Սույնով տալիս եմ իմ համաձայնությունը սույն ծանուցման համաձայն ստանալու և մշակելու իմ վերաբերյալ ցանկացած անձնական տվյալ, ներառյալ՝ ստանալու տեղեկատվություն իմ ներկա և անցյալ ֆինանսական պարտավորությունների վերաբերյալ, ինչպես նաև այլ տվյալներ, որոնք «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ին անհրաժեշտ են ինձ կամ երրորդ անձի (վարկառուի, գրավատուի կամ երաշխավորի) հետ վարկային (փոխառության, գրավի, երաշխավորության և այլն) պայմանագիր կնքելու վերաբերյալ որոշում կայացնելու համար: Ես պարտավորվում եմ «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ին իր պահանջով տրամադրել անձնական տվյալներ: Սույնով նաև հավաստում եմ, որ «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ին երրորդ անձանց անձնական տվյալների տրամադրման համար ստացել եմ նրանց համաձայնությունը: Ես համաձայն եմ, որ ինքնուրույնաբար լիակատար պատասխանատվություն եմ կրում տրամադրված տեղեկատվության ճշգրտության և ամբողջականության համար: Հաստատում եմ, որ սույն համաձայնության շրջանակներում իմ` որպես ֆիզիկական անձի կողմից տրված համաձայնությունը ենթադրում է իմ` որպես անհատ ձեռնարկատիրոջ կողմից տրված համաձայնություն և հակառակը: «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ ծանուցումը և սույն համաձայնությունը կարդացել եմ, հաստատում եմ, որ այն ինձ համար ամբողջությամբ հասկանալի ու ընդունելի է»։",

    /* Validation */
    "required": "Այս դաշտը պարտադիր է",
    "agreementValidationText": "Առանց համաձայնության չենք կարող դիտարկել վարկային հայտը",

    /* Data lists */
    "lists": {
        "subEconomicActivityTypes": [],
        "economicActivityExperienceTypes": [],
        "loanPurposes": [],
        "informationSourceTypes": [],
        "documentTypes": [],
        "documentStatuses": [],
        "currencies": [],
        "addressTypes": [],
        "countries": [],
        "regions": [],
        "cities": [],
        "districts": [],
        "pastDueTypes": [],
        "productTypes": [],
        "pastDue": [{ "key": 1, "value": "Գործող ուշացում չունեմ" }, { "key": 2, "value": "Ունեմ գործող ուշացում" }],
        "businessPeriod": [],
        "businessType": [],
        "period": [],
        "wherefore": ["", "", ""],
        "residences": [{ key: 1, value: "Այո" }, { key: 2, value: "Ոչ" }],
        "resource": ["Սոց. ցանցերով"],
        "responseWays": ["Telegram", "Viber", "Whatsapp", "Mobile"],
        "genders": [{ key: 1, value: "Արական" }, { key: 2, value: "Իգական" }],
        "dayOfBirth": ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"],
        "monthOfBirth": [{ key: 1, value: "Հունվարի" }, { key: 2, value: "Փետրվար" }, { key: 3, value: "Մարտ" }, { key: 4, value: "Ապրիլ" }, { key: 5, value: "Մայիս" }, { key: 6, value: "Հունիս" }, { key: 7, value: "Հուլիս" }, { key: 8, value: "Օգոստոս" }, { key: 9, value: "Սեպտեմբեր" }, { key: 10, value: "Հոկտեմբեր" }, { key: 11, value: "Նոյեմբեր" }, { key: 12, value: "Դեկտեմբեր" }],
        "yearOfBirth": [],
        "product7273AllowedActivities":["11.3","47.9","41.8","63.14"],
        "businessAdvisers":
        [

        // {key:14,value:"Անահիտ Շահբազյան"},
        // {key:23,value:"Դավիթ Հարությունյան"},
        // {key:24,value:"Մարիա Ազարյան"},
        // {key:27,value:"Ասյա Բաղդասարյան"},
        // {key:12,value:"Արման Քոչարյան"},
        // {key:29,value:"Գոռ Պողոսյան"},
        // {key:30,value:"Վահան Վահանյան"},
        // {key:0,value:"Այլ"},
        ]

    }
};

export default labels;
